import { render } from "./DepositCheckout.vue?vue&type=template&id=1368ef54&scoped=true"
import script from "./DepositCheckout.vue?vue&type=script&lang=js"
export * from "./DepositCheckout.vue?vue&type=script&lang=js"

import "./DepositCheckout.vue?vue&type=style&index=0&id=1368ef54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1368ef54"]])

export default __exports__